import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/fight-square-soldier/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/fight-square-soldier',
  name: 'activity_fight_square-soldier',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '消灭方仔大作战',
  },
}

export default [indexRoute]
